<template>
  <page-view fill-height>
    <template #header>
      <base-header
        :title="$t('message.pages.pandaAssist.shortlyPandaAssistAI.title')"
      />
    </template>

    <template #content>
      <div class="fill-height d-flex align-center justify-center">
        <v-row
          class="d-flex flex-column align-center justify-center"
          no-gutters
        >
          <v-row
            class="d-flex flex-column align-center justify-center"
            no-gutters
          >
            <img src="@/assets/shortly-panda-assist-ai.svg" />

            <div class="badge">
              <span class="body-bold-smaller brand-20-darkest--text">{{
                $t('message.pages.pandaAssist.shortlyPandaAssistAI.badge')
              }}</span>
            </div>

            <span class="body-bold-xlarge neutral-20-dark--text">{{
              $t('message.pages.pandaAssist.shortlyPandaAssistAI.title')
            }}</span>
          </v-row>

          <v-row
            class="d-flex flex-column mt-4 align-center justify-center"
            no-gutters
          >
            <span class="body-regular-large neutral-20-dark--text text-center">
              {{
                $t('message.pages.pandaAssist.shortlyPandaAssistAI.information')
              }}
            </span>

            <span
              class="body-regular-base neutral-40-light--text mt-2 text-center"
            >
              {{
                $t('message.pages.pandaAssist.shortlyPandaAssistAI.description')
              }}
            </span>
          </v-row>

          <base-btn class="mt-4" @click="openLink">
            <span class="responsive-text">
              {{ $t('message.pages.pandaAssist.shortlyPandaAssistAI.button') }}
            </span>
          </base-btn>
        </v-row>
      </div>
    </template>
  </page-view>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import PageView from '@/layout/PageViewV2.vue'
import { PANDA_ASSIST_AI_BETA_LINK } from '@/config/envs.js'

export default {
  name: 'Videos',
  components: {
    PageView,
    BaseHeader: () => import('@/components/BaseHeaderV2.vue'),
    BaseBtn,
  },
  methods: {
    openLink() {
      window.open(`${PANDA_ASSIST_AI_BETA_LINK}`, '_blank')
    },
  },
  mounted() {
    localStorage.setItem('hasViewdPandaAssistAI', 'true')
  },
}
</script>

<style lang="scss" scoped>
.badge {
  background-color: varFigma(brand-90);
  color: varFigma(brand-20-darkest);
  border-radius: 8px;
  padding: 0 8px;
  text-transform: uppercase;
  margin: 8px;
}

.fill-height {
  height: 100%;
  padding: 16px;
}
</style>
